import BannerPage from '../components/BannerPage.vue'
import CtaButton from '../components/CtaButton.vue'
import Landing from '../components/Landing.vue'
import Navigation from '../components/Navigation.vue'
import Page from '../components/Page.vue'
import AboutHighlight from '../components/AboutHighlight.vue'
import BusinessAreasHighlight from '../components/BusinessAreasHighlight.vue'
import ContactHighlight from '../components/ContactHighlight.vue'
import CoreValues from '../components/CoreValues.vue'
import ProjectsHighlight from '../components/ProjectsHighlight.vue'
import ServicesHighlight from '../components/ServicesHighlight.vue'

export default {
  install (Vue) {
    Vue.component(BannerPage.name, BannerPage)
    Vue.component(CtaButton.name, CtaButton)
    Vue.component(Landing.name, Landing)
    Vue.component(Navigation.name, Navigation)
    Vue.component(Page.name, Page)
    Vue.component(AboutHighlight.name, AboutHighlight)
    Vue.component(BusinessAreasHighlight.name, BusinessAreasHighlight)
    Vue.component(ContactHighlight.name, ContactHighlight)
    Vue.component(CoreValues.name, CoreValues)
    Vue.component(ProjectsHighlight.name, ProjectsHighlight)
    Vue.component(ServicesHighlight.name, ServicesHighlight)
  }
}
